<template>
  <AddressSearch :service-type="serviceType" :session="session" :defaultAddressId="addressId"/>
</template>

<script>
import {v4 as uuidv4} from 'uuid';

import AddressSearch from './components/AddressSearch.vue'

export default {
  name: 'OrderingUI',
  components: {
    AddressSearch
  },
  data() {
    return {
      serviceType: null,
      session: null,
      addressId: null
    }
  },
  created() {
    const appElem = document.getElementById('ordering-app');
    this.serviceType = appElem ? appElem.getAttribute('service-type') : null;
    this.addressId = appElem ? appElem.getAttribute('address-id') : null;
    this.session = this.generateSessionId()

    const csrfToken = appElem && appElem.getAttribute('csrf-token') ? appElem.getAttribute('csrf-token') : null;
    if (csrfToken) {
      this.$ajax.setCsrfToken(csrfToken);
    }
  },
  methods: {
    generateSessionId() {
      return uuidv4();
    }
  }
}
</script>
